module.exports = __webpack_public_path__ + "static/img/qrcode.e9e07d4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/qrcode.jpg
// module id = Hjk3
// module chunks = 1